


















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import {uniqueId} from 'lodash';
import * as Api from "@/app/interaction/api";

const PREVIEW_ENABLED_MIME_TYPES = ['application/pdf'];

export interface FileDetails {
  title: string;
  description: string;
  uri: string;
  mimeType: string;
  originalFilename: string;
  size: string;
}

@Component
export default class FileComponent extends Vue {

  @Prop({
    required: true
  })
  public content: FileDetails;

  private fileId: string = 'file-'+uniqueId();

  public get hasDescription(): boolean {
    return !!this.content.description && this.content.description.length > 0
  }

  private get downloadFilename(): string|null {
    return this.content.originalFilename;
  }

  private get fileType(): string {
    if (this.content.mimeType === 'application/pdf') {
      return 'pdf';
    } else if (this.content.mimeType === 'application/msword'
            || this.content.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            || this.content.mimeType === 'application/vnd.oasis.opendocument.text') {
        return 'doc';
    } else if (this.content.mimeType === 'application/vnd.ms-excel'
            || this.content.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            || this.content.mimeType === 'application/vnd.oasis.opendocument.spreadsheet') {
      return 'xls';
    } else if (this.content.mimeType === 'application/vnd.ms-powerpoint'
            || this.content.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            || this.content.mimeType === 'application/vnd.oasis.opendocument.presentation') {
      return 'ppt';
    } else if (this.content.mimeType === 'image/jpeg') {
      return 'jpg';
    } else if (this.content.mimeType === 'image/png') {
      return 'png';
    } else if (this.content.mimeType === 'image/gif') {
      return 'gif';
    } else if (this.content.mimeType === 'image/svg+xml') {
      return 'svg';
    } else if (this.content.mimeType === 'image/bmp') {
      return 'bmp';
    } else if (this.content.mimeType === 'image/tiff') {
      return 'tif';
    } else if (this.content.mimeType === 'application/zip'
            || this.content.mimeType === 'application/vnd.rar') {
      return 'zip';
    } else if (this.content.mimeType === 'text/plain'
            || this.content.mimeType === 'application/rtf') {
      return 'txt';
    } else {
      return 'other';
    }
  }

  private get previewEnabled(): boolean {
    return PREVIEW_ENABLED_MIME_TYPES.includes(this.content.mimeType);
  }

  private t(key: string)  {
    return i18n.t(key);
  }
}
